import { ChangeCredentialsDialogState } from './change-credentials-dialog.state';

/**
 * Initialer State für den Change-Credentials-Dialog.
 */
export const changeCredentialsDialogStateInitial: ChangeCredentialsDialogState = {
  isOpen: false,
  title: undefined,
  prompt: undefined,
  url: undefined,
};
